import { render } from "./GameButtons.vue?vue&type=template&id=77b175d7"
import script from "./GameButtons.vue?vue&type=script&lang=js"
export * from "./GameButtons.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__